"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLongDateTimeWithTimeZone = exports.formatDateTimeWithTimeZone = exports.formatTimeZone = exports.formatTime = exports.formatDateTime = exports.formatLongDate = exports.formatShortDateWithWeekday = exports.formatDate = exports.formatDateTimeWithFormat = void 0;
const util_ts_1 = require("@clipboard-health/util-ts");
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
const constants_1 = require("./constants");
class DateTimeFormatError extends Error {
    constructor(dateFormat) {
        super(`Unexpected date time format ${dateFormat}`);
        // See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = "DateTimeFormatError";
    }
}
function getZonedDateTimeFromDateTime(dateTime, timeZone) {
    let dateObject = (0, util_ts_1.isString)(dateTime) ? (0, date_fns_1.parseISO)(dateTime) : dateTime;
    if ((0, util_ts_1.isDefined)(timeZone)) {
        dateObject = (0, date_fns_tz_1.utcToZonedTime)(dateTime, timeZone);
    }
    return dateObject;
}
/**
 * Formats a date according to the given format.
 * @param dateTime - The date to format. If string, will parse it to a date object
 */
function formatDateTimeWithFormat(dateTime, dateFormat, options) {
    if (!constants_1.CBH_DATETIME_FORMATS.includes(dateFormat)) {
        throw new DateTimeFormatError(dateFormat);
    }
    return (0, date_fns_tz_1.format)(getZonedDateTimeFromDateTime(dateTime, options?.timeZone), dateFormat, options);
}
exports.formatDateTimeWithFormat = formatDateTimeWithFormat;
/**
 * Return a formatted date string e.g. "Apr 20, 2023"
 */
function formatDate(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_DATE_FORMAT, options);
}
exports.formatDate = formatDate;
/**
 * Return a formatted short date string with weekday e.g. "Thu, Apr 20"
 */
function formatShortDateWithWeekday(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_SHORT_DATE_WITH_WEEKDAY_FORMAT, options);
}
exports.formatShortDateWithWeekday = formatShortDateWithWeekday;
/**
 * Return a formatted long date string e.g. "Thursday, April 20th, 2023"
 */
function formatLongDate(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_LONG_DATE_FORMAT, options);
}
exports.formatLongDate = formatLongDate;
/**
 * Return a formatted date time string e.g. "Apr 20, 2023, 4:20 PM"
 */
function formatDateTime(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_DATE_TIME_FORMAT, options);
}
exports.formatDateTime = formatDateTime;
/**
 * Return a formatted time string e.g. "4:20 PM"
 */
function formatTime(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_TIME_FORMAT, options);
}
exports.formatTime = formatTime;
/**
 * Return a formatted time zone e.g. "EDT"
 */
function formatTimeZone(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_TIME_ZONE_FORMAT, options);
}
exports.formatTimeZone = formatTimeZone;
/**
 * Return a formatted date time with time zone e.g. "Apr 20, 2023, 4:20 PM EDT"
 */
function formatDateTimeWithTimeZone(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_DATE_TIME_WITH_TIME_ZONE_FORMAT, options);
}
exports.formatDateTimeWithTimeZone = formatDateTimeWithTimeZone;
/**
 * Return a formatted date time with time zone e.g. "Thursday, April 20th, 2023 at 4:20 PM EDT"
 */
function formatLongDateTimeWithTimeZone(date, options) {
    return formatDateTimeWithFormat(date, constants_1.CBH_LONG_DATE_TIME_WITH_TIME_ZONE_FORMAT, options);
}
exports.formatLongDateTimeWithTimeZone = formatLongDateTimeWithTimeZone;
//# sourceMappingURL=format.js.map